
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import addressPicker from '@/views/components/address-picker2'
import config from '@/config'
import banner from '@/assets/manyidadiaocha/banner.png'
import { getSurveyQuestion, postSurvey, check } from '@/api/youzheng'
import { getAddressDefault, getUserAccount, operateCreditlist } from '@/api/user.js'
import { getSurveyList, getTitle } from '@/api/youzheng.js'
import { addPartyCount, getview } from '@/api/jfhl.js'
import { getaddlog } from '@/api/hgfw'
export default {
name: 'quesAsk',
components: {
XTextarea,
XDialog,
Msg,
Toast,
XButton,
XInput,
Group,
PopupPicker,
addressPicker
},
data () {
return {
baseUrl: config.baseUrl,
banner: banner,
title: '',
paperid: '',
activityid: this.$route.params.type,
isclick: false
}
},
created () {
this.gettitleNow()
this.view()
this.getAdd()
this.addIntegral()
this.addcount()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
gettitleNow () {
getTitle({
activityid: this.activityid
}).then(res => {
this.title = res.returnValue.TITLE
})
},

getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120509
}).then(res => {
})
},

addcount () {
addPartyCount({
partyid: this.activityid,
accoutid: this.accountid,
credittype: 1
}).then(res => {
})
},

addIntegral (credit) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule',
credit: 5,
owner_type: '2007',
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => { })
},

view () {
getSurveyList({
activityid: this.activityid
}).then(res => {
console.log(this.title)
if (res.status = 'suc') {
this.isclick = true
this.paperid = res.returnValue.PAPERLIST[0].PAPERID
this.startTime = res.returnValue.PAPERLIST[0].BEGINDATE.replace(/-/g, '/')
this.endTime = res.returnValue.PAPERLIST[0].ENDDATE.replace(/-/g, '/')
this.getcheck()
}
})
},






















getcheck () {
check({
paperid: this.paperid,
accountid: this.accountid
}).then(res => {
if (!res.returnValue.flag) {
this.isclick = false
setTimeout(() => {
this.$vux.alert.show({
content: '您已经填过问卷了！'
})
}, 500)
} else {
this.isclick = true
}
})
},
postAdd () {
if (this.isclick) {
this.$router.push({ name: 'manyidiaocha', params: { type: this.activityid } })
} else {
}
}
}
}
